export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Our Treatment Programs</h2>
          <p>
          {props.data ? props.data.para : 'loading'}
          </p>
        </div>
        <div className='row' >
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className='col-md-4 servicecrd'>
                {' '}
                <a>
                  <img src={d.img} width="300px" height="300px" alt={d.url}></img>
                  <div className='service-desc'>
                    <div className="branch_button">
                      <a href={d.url} className="servicebtn-left">Show Details</a>

                      <a href="/#contact" className="servicebtn-right">Book Appointment</a>
                    </div>
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </a>
              </div>
            ))
            : 'loading'}
        </div>

      </div>
    </div>
  )
}
